import React, { useEffect, useState } from 'react';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { toast } from 'react-toastify';
import { BiRefresh } from 'react-icons/bi';
import SearchBar from '../../components/searchBar/SearchBar';
import Dropdown from '../../components/inputFields/DropDown';
import { getCbbos, getFpos } from '../../services/fpo';
import { statesOfIndia } from '../../constants/states';
import Button from '../../components/buttons/Button';
import { Link } from 'react-router-dom';

function FpoFpo() {
    const [searchText, setSearchText] = useState("");
    const [filteredState, setFilteredState] = useState("");
    const [filterCbbo, setFilterCbbo] = useState("");

    const [cbboDropdownData, setCbboDropdownData] = useState([]);


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Name", key: "name" },
        { label: "Date", key: "updated_at" },
        { label: "CBBO", key: "cbbo_name" },
        { label: "Block", key: "block" },
        { label: "District", key: "district" },
        { label: "State", key: "state" },
        { label: "User Count", key: "user_count" },
        { label: "Action", key: "action" },
    ];

    const pageSize = 50;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getFpos(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
            } else {
                console.log("---------------------------------");
                console.log(res);
                console.log("---------------------------------");
                toast.error(res);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchCbbos = async () => {
        try {
            let res = await getCbbos("");
            if (res.status === 200) {
                const data = res.data;
                setCbboDropdownData(data)
            } else {
                toast.error("Unable to fetch CBBO Dropdown");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        fetchData("");
        fetchCbbos();
    }, []);

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}&date=${filterCbbo}&state=${filteredState}`);
    };

    const handleCbboChange = (value) => {
        setFilterCbbo(value);
        fetchData(`?search=${searchText}&date=${value}&state=${filteredState}`);
    };

    const handleStateChange = (value) => {
        setFilteredState(value);
        fetchData(`?search=${searchText}&date=${filterCbbo}&state=${value}`);
    };

    const resetFilters = () => {
        setSearchText("");
        setFilterCbbo("");
        setFilteredState("");
        fetchData("");
    };

    return (<>
        <div className="flex flex-row gap-2 items-center justify-between">
            <div className="flex gap-2 items-center flex-1">
                <SearchBar
                    placeholder="Start typing here..."
                    onSearch={handleSearch}
                    value={searchText}
                />

                <Dropdown
                    placeholder="Select State"
                    options={statesOfIndia.map((e) => ({ label: e, value: e }))}
                    onChange={handleStateChange}
                    value={filteredState}
                    needSearch
                />

                <div className="w-full max-w-sm">
                    <Dropdown
                        placeholder="Select CBBO"
                        options={cbboDropdownData.map((e) => ({ label: e.name, value: e.id }))}
                        onChange={handleCbboChange}
                        value={filterCbbo}
                        needSearch
                    />
                </div>

                {/* Reset Filters Icon */}
                {(searchText.length !== 0 || filterCbbo !== "" || filteredState !== "") && (
                    <BiRefresh
                        size={24}
                        className="cursor-pointer text-primary"
                        onClick={resetFilters}
                    />
                )}
            </div>
            <Link to="/enquiries/fpos/fpo/add" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add FPO
                </Button>
            </Link>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                name: <p>{item.name}</p>,
                                updated_at: <p>{item.updated_at}</p>,
                                cbbo_name: <p>{item.cbbo_name}</p>,
                                block: <p>{item.block}</p>,
                                district: <p>{item.district}</p>,
                                state: <p>{item.state}</p>,
                                user_count: <p>{item.user_count}</p>,
                                action: <Link to={`/enquiries/fpos/fpo/${item.id}`} state={item} className='self-center'>
                                    <Button
                                        type="button"
                                        className="hover:bg-primary hover:opacity-70 text-white bg-primary/80 rounded-md"
                                    >
                                        Edit
                                    </Button>
                                </Link>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
    </>);
}

export default FpoFpo;